import * as MilesRecoveryStyles from './components/MilesRecovery.css';
import * as MilesRecoveryContentStyles from './components/MilesRecoveryContent/MilesRecoveryContent.css';
export default {
    MilesRecoveryStyles,
    MilesRecoveryContentStyles
};
